(function($) {

  var init = function() {
    var checkWidth = jQuery(window).width();
    var carousel = $(".home .calendar");

    if(checkWidth >= 768) {
      carousel.trigger('destroy.owl.carousel');
      carousel.removeClass('owl-carousel');
    } else {
      carousel.addClass('owl-carousel');
      carousel.owlCarousel({
        loop:true,
        margin:20,
        responsiveClass:true,
        items:1,
        navElement: 'button',
      });
    }    
  };

	$(document).ready(function() {
    init();
  });

  $(window).resize(function() {
    init();
  });

})(jQuery);